import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import css from './Paginator.module.scss'

type Props = {
  count: number
  index: number
}

const WINDOW = 3

function distance(index: number, active: number): number {
  return Math.abs(index - active)
}

export const Paginator = observer(({ count, index }: Props) => {
  if (count < 2) return null

  const dots = Array.from({ length: count }, (_, i) => i)
    .map(i => ({ i, d: distance(i, index) }))
    .filter(it => it.d <= WINDOW)

  return <Space className={css.paginator} gap={16} center>
    {dots.map(({ i, d }) => (
      <Space key={i} className={clsx(css.dot, css[`d${d}`])} />
    ))}
  </Space>
})
